module.exports = __webpack_public_path__ + "img/thomas-edison.1cf62c38.png";